<div class="card">
   <p>Dashboard</p>


   <!-- <span class="material-symbols-outlined">
      compare_arrows
      </span>

      <i class="material-symbols-outlined text-7xl">javascript</i> -->
</div>
